/* eslint-disable react/display-name */
import { useModal } from "@/context/ModalContext";
import { SecondaryButton } from "@jammable/ui-core";
import React, {
  useRef,
  useState,
  forwardRef,
  useImperativeHandle,
} from "react";
import AvatarEditor from "react-avatar-editor";
import { HiPencil } from "react-icons/hi";
import { RxUpload } from "react-icons/rx";
import GenerateImageModal from "./modals/GenerateImageModal";

const UploadImage = forwardRef(({ setImage, image }, ref) => {
  const [localImage, setLocalImage] = useState(image ?? null);
  const editorRef = useRef(null);

  const handleImageChange = (e) => {
    if (e.target.files && e.target.files.length > 0) {
      setLocalImage(URL.createObjectURL(e.target.files[0]));
      setImage(e.target.files[0]);
    }
  };

  useImperativeHandle(ref, () => ({
    getCroppedImageFile: () => {
      return new Promise((resolve, reject) => {
        if (editorRef.current) {
          editorRef.current.getImage().toBlob((blob) => {
            if (!blob) return reject(new Error("Could not export the image"));
            const file = new File([blob], `picture.png`, {
              type: "image/png",
            });
            resolve(file);
          });
        } else {
          reject(new Error("Editor reference is not set"));
        }
      });
    },
  }));

  const { openModal } = useModal();

  return (
    <div className="tw-w-full tw-flex tw-justify-center tw-items-center">
      {localImage ? (
        <div
          onClick={() => {
            setLocalImage(null);
            setImage(null);
          }}
          className="tw-size-40  tw-relative tw-flex tw-items-center tw-cursor-pointer tw-justify-center"
        >
          <div style={{ display: "flex", justifyContent: "center" }}>
            <AvatarEditor
              ref={editorRef}
              image={localImage}
              border={0}
              scale={1}
              width={160}
              height={160}
              rotate={0}
              disableHiDPIScaling
              className="tw-rounded-3xl"
            />
          </div>
          <HiPencil
            className="tw-absolute tw-text-white tw-bg-none"
            size={50}
          />
        </div>
      ) : (
        <div className="tw-size-40 tw-relative  tw-flex tw-rounded-xl tw-items-center tw-justify-center">
          <div className="tw-size-40 tw-flex-col tw-gap-1 tw-cursor-pointer tw-font-bold tw-border-2 tw-border-zinc-300 tw-border-dashed tw-rounded-3xl tw-flex tw-items-center tw-justify-center tw-text-center">
            <div className="tw-bg-purple-200 tw-flex tw-items-center tw-p-2 tw-text-purple-600 tw-justify-center tw-rounded-xl">
              <RxUpload size={20} strokeWidth={1} />
            </div>
            <div className="tw-mt-1">Upload Image</div>
            <span className="tw-text-xs tw-text-black/40 tw-font-semibold">
              PNG, JPG or JPEG
            </span>
            <SecondaryButton
              onClick={(e) => {
                e.preventDefault();
                e.stopPropagation();
                openModal(
                  "generate-image-modal",
                  <GenerateImageModal
                    setLocalImage={setLocalImage}
                    setImage={setImage}
                  />,
                );
              }}
              className="tw-rounded-full tw-w-max md:tw-px-2 tw-h-8 tw-z-20"
            >
              ✨ Generate
            </SecondaryButton>
          </div>
          <input
            type="file"
            id="newImage"
            name="newImage"
            accept=".png, .jpg, .jpeg"
            onChange={handleImageChange}
            className="tw-absolute tw-aspect-square tw-left-0 tw-w-full tw-h-full tw-opacity-0 tw-cursor-pointer"
          />
        </div>
      )}
    </div>
  );
});

export default UploadImage;
